import { render } from "./EditLanguage.vue?vue&type=template&id=29b71df0&ts=true"
import script from "./EditLanguage.vue?vue&type=script&lang=ts"
export * from "./EditLanguage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\slow\\slowshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__